import { DEFAULT_LOCALE } from '@/utils/constants';

import {
  useGetArticleBySlugQuery,
  useGetCaseStudiesQuery,
  useGetCaseStudyBySlugQuery,
  useGetInventoryDefinitionsFilteredBySlugQuery,
} from '../generated';
import { PublicationState, useGetDynamicPageBySlugQuery, useGetProposedCaseStudiesQuery } from '../generated/graphql';

export async function getCaseStudiesData() {
  const queryResult = await useGetCaseStudiesQuery.fetcher()();

  return queryResult.caseStudies?.data;
}

export function getPublicationState(preview: boolean) {
  return preview ? PublicationState.Preview : PublicationState.Live;
}

export async function getCaseStudyData(slug: string, preview = false, locale = DEFAULT_LOCALE) {
  const publicationState = getPublicationState(preview);

  const queryResult = await useGetCaseStudyBySlugQuery.fetcher({
    slug,
    publicationState,
    locale,
  })();

  return queryResult.caseStudies?.data[0]?.attributes;
}

export function useGetCaseStudyData(slug: string, preview = false, locale = DEFAULT_LOCALE) {
  const publicationState = getPublicationState(preview);

  return useGetCaseStudyBySlugQuery({
    slug,
    publicationState,
    locale,
  }).data?.caseStudies?.data[0]?.attributes!;
}

export function useGetProposedCaseStudiesData(slug: string) {
  return (
    useGetProposedCaseStudiesQuery({
      slug,
    }).data?.caseStudies?.data || []
  );
}

export async function getArticleData(slug: string, preview = false, locale = DEFAULT_LOCALE) {
  const queryResult = await useGetArticleBySlugQuery.fetcher({
    slug,
    isPreview: preview,
    locale,
  })();

  return queryResult.article?.data?.attributes;
}

export function useGetDynamicPageData(slug: string, preview = false, locale = DEFAULT_LOCALE) {
  const publicationState = getPublicationState(preview);

  return useGetDynamicPageBySlugQuery({
    slug,
    publicationState,
    locale,
  }).data?.pages?.data[0]?.attributes!;
}

export async function getDynamicPageData(slug: string, preview = false, locale = DEFAULT_LOCALE) {
  const publicationState = getPublicationState(preview);

  const queryResult = await useGetDynamicPageBySlugQuery.fetcher({
    slug,
    publicationState,
    locale,
  })();

  return queryResult.pages?.data[0]?.attributes;
}

export function useGetArticlesData(slug: string, preview = false, locale = DEFAULT_LOCALE) {
  return useGetArticleBySlugQuery({
    slug,
    isPreview: preview,
    locale,
  }).data?.article?.data?.attributes!;
}

export async function getInventoryDefinitionData(slug: string, preview = false, locale = DEFAULT_LOCALE) {
  const publicationState = getPublicationState(preview);

  const queryResult = await useGetInventoryDefinitionsFilteredBySlugQuery.fetcher({
    slug,
    publicationState,
    locale,
  })();

  return queryResult.inventoryDefinitions?.data[0]?.attributes;
}

export function useGetInventoryDefinitionData(slug: string, preview = false, locale = DEFAULT_LOCALE) {
  const publicationState = getPublicationState(preview);

  return useGetInventoryDefinitionsFilteredBySlugQuery({
    slug,
    publicationState,
    locale,
  }).data?.inventoryDefinitions?.data[0]?.attributes!;
}
